import { StyleSheet } from 'react-native'
import type { Theme } from '../../../src/theme/getTheme'
import { BRACKET_BOX_MIN_H, BRACKET_BOX_W } from './knockoutBracket.constants'

export const getKnockoutMatchBoxStyles = (theme: Theme) =>
  StyleSheet.create({
    box: {
      width: BRACKET_BOX_W,
      minHeight: BRACKET_BOX_MIN_H,
      paddingVertical: 8,
      paddingHorizontal: 6,
      borderRadius: theme.borderRadius.lg,
      backgroundColor: theme.background.card,
      borderWidth: 1,
      borderColor: theme.gray[200],
      justifyContent: 'center',
    },
    pressed: {
      backgroundColor: theme.background.cardElevated,
      borderColor: theme.primary,
    },
    teamsRow: {
      flexDirection: 'row',
      justifyContent: 'space-around',
      alignItems: 'flex-start',
    },
    date: {
      marginTop: 5,
      fontSize: 10.5,
      fontWeight: '500',
      color: theme.gray[400],
      textAlign: 'center',
    },
    /**
     * The per-leg breakdown under a two-legged tie's aggregate (AC-6.7). Deliberately quieter
     * and smaller than the date: the aggregate is what decides the tie, and these only explain
     * how it was reached.
     */
    legs: {
      marginTop: 3,
      fontSize: 9.5,
      fontWeight: '600',
      color: theme.gray[500],
      textAlign: 'center',
      fontVariant: ['tabular-nums'],
    },
    pens: {
      marginTop: 2,
      fontSize: 9.5,
      fontWeight: '700',
      color: theme.gray[400],
      textAlign: 'center',
      fontVariant: ['tabular-nums'],
    },
    badge: {
      alignSelf: 'center',
      marginTop: 5,
      paddingHorizontal: 7,
      paddingVertical: 2,
      borderRadius: theme.borderRadius.full,
    },
    badgeFinal: {
      backgroundColor: theme.accent,
    },
    badgeBronze: {
      backgroundColor: theme.info,
    },
    badgeText: {
      fontSize: 9,
      fontWeight: '800',
      letterSpacing: 0.4,
    },
    badgeTextFinal: {
      color: theme.textOnStatusBadge,
    },
    badgeTextBronze: {
      color: theme.white,
    },
  })
